import React, { Component } from 'react';
import {connect} from 'react-redux';
import PropTypes from "prop-types";
import { Link } from 'react-router-dom';

const slug = {
  es: ['aviso-legal', 'condiciones-del-servicio', 'politica-de-privacidad', 'politica-de-cookies'],
  fr: ['avis-juridique', 'conditions-d-utilisation', 'politique-de-confidentialite', 'politique-de-cookies']

}

class footer extends Component {
  static contextTypes = {
    router: PropTypes.object
  }

  render() {
    const langUrl = this.context.router.route.location.pathname.split('/')[1]
    const { languages } = this.props.settings
    const langPlace = languages[langUrl].footer

    const path = this.context.router.route.location.pathname
    const lang = path.split('/')[1]

    return (
      <div className="container-fluid footer">

        <footer id="footer" className="row">
          <div className="bottom-section">
            <div className="container">
              <div className="flex-row">
                <nav className="menu">
                  <ul className="menu-list no-margin no-padding regular">
                    <li className="menu-list-item white-link-container"><Link to={`/${lang}/${slug[lang][0]}`}>{langPlace.legal}</Link></li>
                    <li className="menu-list-item white-link-container"><Link to={`/${lang}/${slug[lang][1]}`}>{langPlace.conditions}</Link></li>
                    <li className="menu-list-item white-link-container"><Link to={`/${lang}/${slug[lang][2]}`}>{langPlace.privacitat}</Link></li>
                    <li className="menu-list-item white-link-container"><Link to={`/${lang}/${slug[lang][3]}`}>{langPlace.cookies}</Link></li>
                    <li className="menu-list-item white-link-container"><a href="mailto:pasajes@romeuycia.com">pasajes@romeuycia.com</a></li>
                  </ul>
                </nav>
                <a className="brand" href="http://www.gruporomeu.com" target="_blank" rel="noopener noreferrer">
                  <img src={require("../../images/LogoGrupRomeu.png")} alt="Romeu Ferries"/>
                </a>
              </div>
            </div>
          </div>
        </footer>

      </div>
    );
  }
}

export default connect(
  (state) => ({settings: state.settings})
)(footer)



// WEBPACK FOOTER //
// ./src/shared/routes/components/footer.js